import axios from "axios";
import { Api_Url } from "./ApiUrl";

const apiClient = axios.create({
  baseURL: Api_Url,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.log("401 Unauthorized - Token might be invalid or expired");
    }
    return Promise.reject(error);
  }
);

export default apiClient;
